var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgAlert = function SvgAlert(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8.303.6c.799-.8 2.095-.8 2.894 0l7.704 7.703a2.047 2.047 0 0 1 0 2.894l-7.704 7.704a2.047 2.047 0 0 1-2.894 0L.6 11.197c-.8-.799-.8-2.095 0-2.894zm1.654 1.24a.29.29 0 0 0-.414 0L1.84 9.543a.29.29 0 0 0 0 .414l7.703 7.703c.114.114.3.114.414 0l7.703-7.703a.29.29 0 0 0 0-.414z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.713 4.197c.484 0 .877.393.877.877v4.679a.877.877 0 0 1-1.754 0V5.074c0-.484.392-.877.877-.877",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.69 11.883a1.17 1.17 0 1 0 0 2.34 1.17 1.17 0 0 0 0-2.34"
  })));
};
export default SvgAlert;